import React from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router';

import { getAppUIVariantConfig } from 'Util/uiVariantSet';
import { AccessContentModal, MESSAGE_TYPE } from 'Components/AccessContentModal';
import { useConfig } from 'Context/ConfigContext';

const EnterClassroomErrorModal = ({ isActive, onContinue }) => {
  const { Modal } = getAppUIVariantConfig();
  const history = useHistory();
  const { landingRoute = '/my-courses' } = useConfig();
  const handleGoToLandingPage = () => {
    if (typeof onContinue === 'function') {
      return onContinue();
    }
    return history.replace(landingRoute);
  };

  switch (Modal) {
    case 'Rounded':
    default: {
      return (
        <AccessContentModal
          messageType={MESSAGE_TYPE.ENTER_CLASSROOM_ERROR}
          muiProps={{ isActive }}
          onClick={handleGoToLandingPage}
        />
      );
    }
  }
};

EnterClassroomErrorModal.propTypes = {
  isActive: PropTypes.bool,
  onContinue: PropTypes.func,
};

export default EnterClassroomErrorModal;
